// extracted by mini-css-extract-plugin
export default {"wrapper":"issues_wrapper__syUxK","container":"issues_container__DxJ91","box":"issues_box__wZTo7"};